<template>
  <div>
    <div class="col-md-12">
      <h4 class="site-heading my-3">
        <span>REFID(Delete)</span>
      </h4>
    </div>
    <div class="form-group col-sm-12">
      <table class="table table-bordered builder-table has-aggregate-function">
        <thead>
          <th>Select REFID</th>
          <th>Condition Operator</th>
          <th>Joining Rule</th>
          <th style="width: 50px">Action</th>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">
            <td>
              <select class="form-control" v-model="row.condition_field">
                <option
                  :value="conditionField.key"
                  v-for="conditionField in conditionFields"
                >
                  {{ conditionField.value }}
                </option>
              </select>
            </td>
            <td>
              <select class="form-control" v-model="row.condition_op">
                <option
                  :value="condition_op.key"
                  v-for="condition_op in conditionOperators"
                >
                  {{ condition_op.value }}
                </option>
              </select>
            </td>
            <td style="text-align: center">
              <select class="form-control" v-model="row.joining_rules">
                <option :value="joining.key" v-for="joining in joiningRules">
                  {{ joining.value }}
                </option>
              </select>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-danger btn-sm"
                @click="deleteRow(index)"
              >
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <button
        type="button"
        @click="addRow"
        class="btn btn-success btn-sm float-right mt-2"
      >
        <i class="fa fa-plus"></i>&nbsp;New REFID
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  props: ["delete_refid_condition"],
  computed: {
    ...mapGetters(["conditionFields", "conditionOperators", "joiningRules"]),
  },
  data: () => ({
    rows: [],
  }),
  components: { Multiselect },
  methods: {
    addRow() {
      this.rows.push({
        condition_field: "",
        condition_op: "",
        joining_rules: "",
      });
    },
    deleteRow: function (index) {
      this.rows.splice(index, 1);
    },
  },
  watch: {
    delete_refid_condition: function (val, oldVal) {
      this.rows = val;
    }
  },
  updated() {
    this.$emit("updateRefIdDelete", this.rows);
  },
};
</script>
<style></style>
